;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { queryFetcher } from "@/queries/config/query-fetcher";
import { systemViewQueryKeys } from "@/queries/query-keys/system-views";
import { ViewType } from "@/types/view";

export interface SystemView {
	id: string;
	name: string;
	description?: string;
}

/**
 * Fetches system views. The API returns a JSON array (`apiSuccess(views)`), not `{ views: [...] }`.
 * Pass `workspaceId` to return only views that can still be added to that workspace.
 */
export async function getSystemViews(
	workspaceId?: string,
): Promise<SystemView[]> {
	const searchParams = new URLSearchParams({
		type: ViewType.SYSTEM_VIEW,
	});

	if (workspaceId) {
		searchParams.set("workspaceId", workspaceId);
	}

	return queryFetcher(`/api/views?${searchParams.toString()}`, {
		method: "GET",
	});
}

export function getSystemViewsQueryOptions(workspaceId?: string) {
	return queryOptions({
		enabled: workspaceId === undefined ? true : Boolean(workspaceId),
		placeholderData: keepPreviousData,
		queryFn: () => getSystemViews(workspaceId),
		queryKey: systemViewQueryKeys.list(workspaceId),
	});
}
